import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DelayedDispatchService } from '../../service/delayed-dispatch.service';
import { NgxSpinnerService } from "ngx-spinner";

import { QueryWrapper } from '../../model/query-wrapper.model';
import { SelectItem ,ToastMessageOptions} from 'primeng/api';

@Component({
    selector: 'app-allo-rate-master',
    templateUrl: './allo-rate-master.component.html',
    styleUrls: ['./allo-rate-master.component.css'],
    standalone: false // NOSONAR,
})
export class AlloRateMasterComponent implements OnInit {

  errMsgs: ToastMessageOptions[] = [];
  fiscalYears: SelectItem[] = [];
  fiscalYear: string;
  currentYear: number;
  pipe: DatePipe;
  addDomicileClicked: boolean = false;
  addYearClicked: boolean = false;
  copyYearClicked: boolean = false;
  domicile: string;
  otr: string;
  handling: string;
  inpFiscalYear: string;
  existingAPRCosts: any;
  filters: any;
  aprCostsCols: any;
  aprCostSelectedValues: any[] = [];
  newFiscalYear: string;

  constructor(private readonly service: DelayedDispatchService, 
    
    private readonly spinnerService: NgxSpinnerService
    ) { }

  ngOnInit() { // NOSONAR
    this.currentYear = new Date().getFullYear();
    this.pipe = new DatePipe('en-US');
    this.getExistingFiscalYears();
    this.aprCostsCols = [
      { field: '', header: 'Select' },
      { field: 'domicile', header: 'Domicile' },
      { field: 'overTheRoad', header: 'OTR' },
      { field: 'handlingCharge', header: 'Handling' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'createdDate', header: 'Created Date' }
    ];
  }

  getExistingFiscalYears() {
    this.service.getAlloFiscalYears().subscribe(data => {
      this.fiscalYears = [];
      this.setFiscalYears(data);
    }
    );
  }

  setFiscalYears(data) {
    for (const entry of data) {
      this.fiscalYears.push(
        { label: entry.fiscalYear, value: entry.fiscalYear }
      );
    }
  }

  onChange(_event) {
    this.errMsgs = [];
    this.addDomicileClicked = false;
    this.addYearClicked = false;
    this.aprCostSelectedValues = [];
    this.getAPRCostsForFiscalYear();
  }

  copyFiscalYear() {
    this.copyYearClicked = true;
    this.addDomicileClicked = false;
    this.addYearClicked = false;
    this.errMsgs = [];
  }

  addDomicile() {
    this.addDomicileClicked = true;
    this.addYearClicked = false;
    this.copyYearClicked = false;
    this.errMsgs = [];
  }

  addFiscalYear() {
    this.addYearClicked = true;
    this.addDomicileClicked = false;
    this.copyYearClicked = false;
    this.errMsgs = [];
  }

  cancelCopy() {
    this.copyYearClicked = false;
  }

  cancelAddYear() {
    this.addYearClicked = false;
  }

  cancelAddDomicile() {
    this.addDomicileClicked = false;
  }

  copyExistingFiscalYear() {
    this.validateCopyFiscalYearInput();
    if (this.errMsgs.length == 0) { // NOSONAR
      this.spinnerService.show();
      const qw = new QueryWrapper();
      qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
      qw.searchCriteriaMap['newFiscalYear'] = this.newFiscalYear;
      this.service.copyFiscalYear(qw).subscribe(
        (data: any) => {
          if (data != null) { // NOSONAR
            this.messageHandler(data);
            this.spinnerService.hide();
          } else {
            this.newFiscalYear = '';
            this.copyYearClicked = false;
            this.existingAPRCosts = '';
            this.getExistingFiscalYears();     
            this.errMsgs = [];       
            this.errMsgs.push({ severity: 'success', summary: 'The copy of Fiscal Year creation success!', detail: '' });
            this.spinnerService.hide();
          }
        },
        (error: any) => { 
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
          this.spinnerService.hide();
        }
      );
    } else {
      return;
    }
  }

  addDomicileToMaster() {
    this.validateCostInput();
    if (this.errMsgs.length == 0) { // NOSONAR
      this.spinnerService.show();
      const qw = new QueryWrapper();
      qw.searchCriteriaMap['domicile'] = this.domicile;
      qw.searchCriteriaMap['otr'] = this.otr;
      qw.searchCriteriaMap['handling'] = this.handling;
      qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
      this.service.addAlloAPRCost(qw).subscribe(
        (data: any) => {
          if (data != null) { // NOSONAR
            this.messageHandler(data);
            this.spinnerService.hide();
          } else {
            this.domicile = '';
            this.otr = '';
            this.handling = '';
            this.getAPRCostsForFiscalYear();
            this.errMsgs = [];
            this.errMsgs.push({ severity: 'success', summary: 'The Domicile has been added successfully!', detail: '' });
            this.spinnerService.hide();
          }
        },
        (error: any) => {
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
          this.spinnerService.hide();
        }
      );
    } else {
      return;
    }
  }

  getAPRCostsForFiscalYear() {
    const qw = new QueryWrapper();
    qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
    this.service.getAlloAPRCostsOfFiscalYear(qw).subscribe(
      (data: any) => {
        this.existingAPRCosts = data;
        this.addYearClicked = false;
        this.addDomicileClicked = false;
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  addFiscalToTable() {
    this.validateFiscalYearInput();
    if (this.errMsgs.length == 0) { // NOSONAR
      this.spinnerService.show();
      const qw = new QueryWrapper();
      qw.searchCriteriaMap['inpFiscalYear'] = this.inpFiscalYear;
      this.service.addAlloFiscalYear(qw).subscribe(
        (data: any) => {
          if (data != null) { // NOSONAR
            this.messageHandler(data);
            this.spinnerService.hide();
          } else {
            this.inpFiscalYear = '';
            this.addYearClicked = false;
            this.getExistingFiscalYears();
            this.errMsgs = [];
            this.errMsgs.push({ severity: 'success', summary: 'The Fiscal Year has been added successfully!', detail: '' });
            this.spinnerService.hide();
          }
        },
        (error: any) => {
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
          this.spinnerService.hide();
        }
      );
    } else {
      return;
    }
  }

  upateAPRCosts() {
    this.errMsgs = [];
    this.spinnerService.show();
    const qw = new QueryWrapper();
    qw.alloAprRateMaster['selectedAprCosts'] = this.aprCostSelectedValues;
    qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
    this.service.updateSelectedAPRCosts(qw).subscribe(
      (data: any) => {
        if (data != null) { // NOSONAR
          this.messageHandler(data);
          this.spinnerService.hide();
        } else {
          this.aprCostSelectedValues = [];
          this.getAPRCostsForFiscalYear();
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'success', summary: 'The selected entities have been updated successfully.', detail: '' });
          this.spinnerService.hide();
        }
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  deleteAPRCosts() {
    this.errMsgs = [];
    this.spinnerService.show();
    const qw = new QueryWrapper();
    qw.alloAprRateMaster['selectedAprCosts'] = this.aprCostSelectedValues;
    qw.searchCriteriaMap['fiscalYear'] = this.fiscalYear;
    this.service.deleteSelectedAPRCosts(qw).subscribe(
      (data: any) => {
        if (data != null) { // NOSONAR
          this.messageHandler(data);
          this.spinnerService.hide();
        } else {
          this.aprCostSelectedValues = [];
          this.getAPRCostsForFiscalYear();
          this.errMsgs = [];
          this.errMsgs.push({ severity: 'success', summary: 'The selected entities have been deleted successfully.', detail: '' });
          this.spinnerService.hide();
        }
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  validateFiscalYearInput() {
    this.errMsgs = [];
    if (this.inpFiscalYear == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Please enter a valid fiscal year.", detail: '' });
    } else if (this.inpFiscalYear.length != 4) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Fiscal year must be 4 numerics.", detail: '' });
    } else {
      const isValidYear = !/\D/.test(this.inpFiscalYear);
      if (!isValidYear) {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: "Fiscal year must be numerics only.", detail: '' });
      }
    }
  }

  validateCopyFiscalYearInput() {
    this.errMsgs = [];
    if (this.newFiscalYear == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Please enter a valid fiscal year.", detail: '' });
    } else if (this.newFiscalYear.length != 4) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Fiscal year must be 4 numerics.", detail: '' });
    } else {
      const isValidYear = !/\D/.test(this.newFiscalYear);
      if (!isValidYear) {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: "Fiscal year must be numerics only.", detail: '' });
      }
    }
  }

  validateCostInput() {
    this.errMsgs = [];
    if (this.domicile == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Domicile is required.", detail: '' });
    }

    if (this.otr == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "OTR is required.", detail: '' });
    } else {
      const isValidOtr = /^\d+\.\d+$|^\d+$/.test(this.otr);
      if (!isValidOtr) {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: "OTR should contain only numerics and period.", detail: '' });
      }
    }

    if (this.handling == null) { // NOSONAR
      this.errMsgs = [];
      this.errMsgs.push({ severity: 'error', summary: "Handling is required.", detail: '' });
    } else {
      const isValidHandling = /^\d+\.\d+$|^\d+$/.test(this.handling);
      if (!isValidHandling) {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: "Handling should contain only numerics and period.", detail: '' });
      }
    }
  }

  messageHandler(data) {
    this.messageHandlerType(data, 'error');
  }

  messageHandlerType(data, type) {
    this.errMsgs = [];
    if (data.messages != undefined && data.messages.length != 0) { // NOSONAR
      for (const entry of data.messages) {
        for (const mes of entry.message.sort()) {
          this.setMessage(type, mes);
        }
      }
      return;
    }
  }

  setMessage(type, desc) {
    this.errMsgs.push({ severity: type, summary: desc, detail: '' });
  }

  filterCapture(_event, data) {
    this.filters = data.filters;
  }

  convertDateFormat(date) {
    return this.pipe.transform(date, 'MM/dd/yyyy', 'EST');
  }
}
